<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx">
            変更後のお電話番号をご入力ください。
          </p>
          <div :class="`Form__input_box Form__input_box--xlg ${$v.userInfo.phone.$error || $v.userInfo.phone1.$error || $v.userInfo.phone2.$error || $v.userInfo.phone3.$error ? '_error' : ''}`">
            <div class="Form-group-custom" style="margin-top: 30px;">
              <input
                v-model="$v.userInfo.phone1.$model"
                class="Form__input Form__input_number"
                placeholder="079"
                inputmode="decimal"
                pattern="\\d*"
                type="number"
                min="1"
                @keypress="onlyNumber"
                @input="updatePhoneNumber"
                @click="clearText()"
              >
              <label class="number-seperate">-</label>
              <input
                v-model="$v.userInfo.phone2.$model"
                class="Form__input Form__input_number"
                placeholder="1234"
                inputmode="decimal"
                pattern="\\d*"
                type="number"
                @keypress="onlyNumber"
                @input="updatePhoneNumber"
                @click="clearText()"
              >
              <label class="number-seperate">-</label>
              <input
                v-model="$v.userInfo.phone3.$model"
                class="Form__input Form__input_number"
                placeholder="5678"
                inputmode="decimal"
                pattern="\\d*"
                type="number"
                @keypress="onlyNumber"
                @input="updatePhoneNumber"
                @click="clearText()"
              >
            </div>
            <div class="Form__error_box">
              <div class="Form__error_tx">
                <label v-if="!$v.userInfo.phone1.required || !$v.userInfo.phone2.required || !$v.userInfo.phone3.required">電話番号を入力してください</label>
                <label v-if="isPhoneFullInput() && (!$v.userInfo.phone.maxLength || !$v.userInfo.phone.minLength)">10~15文字で設定してください</label>
              </div>
            </div>
          </div>
          <button :disabled="$v.userInfo.$invalid || isLoading" class="Btn__blue Form__btn Form__btn--sm_sp Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg" @click="updateUserInfo()">
            変更する
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'
import checkNumber from '@/helpers/onlyNumber'
const touchMap = new WeakMap()
const validations = {
  userInfo: {
    phone: {
      required,
      maxLength: maxLength(17),
      minLength: minLength(12)
    },
    phone1: {
      required
    },
    phone2: {
      required
    },
    phone3: {
      required
    }
  }
}
export default {
  name: 'ChangeTell',
  mixins: [validationMixin],
  data() {
    return {
      userInfo: {
        phone1: '',
        phone2: '',
        phone3: '',
        phone: ''
      },
      isLoading: false,
      showError: false,
      isFirstClick: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    clearText() {
      if (this.isFirstClick) {
        this.userInfo = {
          phone1: '',
          phone2: '',
          phone3: '',
          phone: ''
        }
        this.isFirstClick = false
      }
    },
    onlyNumber($event) {
      checkNumber.onlyNumber($event)
    },
    async init() {
      await this.getUserInfo()
    },
    async getUserInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserInfo()
      const userInfoData = response.user.user
      this.userInfo.phone = userInfoData.phone || ''
      if (this.userInfo.phone.includes('-')) {
        this.userInfo.phone1 = this.userInfo.phone.split('-')[0]
        this.userInfo.phone2 = this.userInfo.phone.split('-')[1]
        this.userInfo.phone3 = this.userInfo.phone.split('-')[2]
      } else {
        this.userInfo.phone1 = this.userInfo.phone.substring(0, 3)
        this.userInfo.phone2 = this.userInfo.phone.substring(3, 7)
        this.userInfo.phone3 = this.userInfo.phone.substring(7, this.userInfo.phone.length)
        this.userInfo.phone = [this.userInfo.phone1, this.userInfo.phone2, this.userInfo.phone3].join('-')
      }
      this.$store.dispatch('loading/updateLoading', false)
    },
    async updateUserInfo() {
      this.isLoading = true
      this.$v.userInfo.$touch()
      if (this.$v.userInfo.$invalid) {
        return
      }
      const redirectPath = '/change/tell/thanks'
      await authService.updateUserInfo({ telephone_number: this.userInfo.phone })
        .then((response) => {
          this.isLoading = false
          redirect(redirectPath)
        })
        .catch(
          this.showError = true
        )
        .finally(
          this.isLoading = false
        )
      redirect(redirectPath)
    },
    delayTouch($v) {
      $v.$reset()
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set($v, setTimeout($v.$touch, 1000))
    },
    updatePhoneNumber() {
      this.userInfo.phone = [this.userInfo.phone1, this.userInfo.phone2, this.userInfo.phone3].join('-')
      if (this.isPhoneFullInput()) {
        this.delayTouch(this.$v.userInfo.phone)
      }
    },
    isPhoneFullInput() {
      return this.userInfo.phone1 && this.userInfo.phone2 && this.userInfo.phone3
    }
  },
  validations: validations
}
</script>
